// DEPENDENCIES
import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import ICON_BACK from "@mui/icons-material/KeyboardBackspace";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import toast from "react-hot-toast";
import moment from "moment";
// CUSTOM COMPONENTS
import IMAGE_outstanding from "../../../../../img/testmodule/outstanding.png";
import IMAGE_Excellent from "../../../../../img/testmodule/Excellent_img.png";
import IMAGE_VGood from "../../../../../img/testmodule/VeryGood_Img.png";
import IMAGE_Good from "../../../../../img/testmodule/Good_Img.png";
import IMAGE_Average from "../../../../../img/testmodule/Average_img.png";
import IMAGE_AAverage from "../../../../../img/testmodule/AboveAverage_Img.png";
import IMAGE_BAverage from "../../../../../img/testmodule/BelowAverage_Img.png";

// UI COMPONENTS
import FloatedTitleContainer from "../../../../../ui/FloatedTitleContainer";
import PrimaryButton from "../../../../../ui/PrimaryButton";
import NavigationButton from "../../../../../ui/NavigationButton";
import SecondaryButton from "../../../../../ui/SecondaryButton";
import CustomContainer from "../../../../../ui/CustomContainer";
import SkeletonLoaderPage from "../../../../../ui/SkeletonLoaderPage";
import ButtonContainer from "../../../../../ui/ButtonContainer";
import StyledTitle from "../../../../../ui/StyledTitle";
// CONFIG
import { AxiosInstance } from "../../../../../axios";
import { ImageUrlPrefix } from "../../../../../labels";
import {
  apiSubjectListforTimeTakenChart,
  getTestTypes,
  perfomanceBasicInfo,
  studentPerfomanceChart,
} from "../../../../../services/services";
import {
  CHART_OVERALL,
  CHART_PERFOMANCE,
  CHART_PROFICIENCY_SUBJECTS,
  CHART_QUESTION_TYPE,
  CHART_SUBJECT_TIME_TAKEN,
  DONUTBACKGROUNDCOLOR,
  MEDIA_SIZE_LG,
  MEDIA_SIZE_MD,
  QUESTION_TYPE_EASY,
  QUESTION_TYPE_HARD,
  QUESTION_TYPE_MEDIUM,
  QUESTION_TYPE_VERY_EASY,
  QUESTION_TYPE_VERY_HARD,
  TESTTYPE_DAILY,
  TESTTYPE_MODEL,
  TESTTYPE_MONTH,
  TESTTYPE_REVISION,
  TESTTYPE_SPOT,
  TESTTYPE_TOPIC_WISE,
  TESTTYPE_UNIT_WISE,
  TESTTYPE_WEEK,
  capitalizeFirstLetter,
} from "../../../../../utils/helper";
import {
  createEventDifficultyTypeData,
  createOverallAnalysisScore,
  createOverallDifficultyTypeData,
  createPerfomanceLabels,
  createPerfomanceStudentScore,
  createPerfomanceTitle,
  createPerfomanceTopperScore,
  createProficiencySubjectAnalysisScore,
  createSubjectWiseTimeTaken,
} from "../../../../../redux/ChartSlice";
import styles from "./ViewInterviewPerfomance.module.css";
import TestDetailsNumbers from "../../StudentTestWorkflow/components/TestDetailsNumbers";
import PieChart from "../../StudentTestWorkflow/components/PieChart";
import DonutChart from "../../StudentTestWorkflow/components/DonutChart";
import LineChart from "../../StudentTestWorkflow/components/LineChart";
import BarChart from "../../StudentTestWorkflow/components/BarChart";
import HorizontalBarChart from "../../StudentTestWorkflow/components/HorizontalBarChart";

// const ContainerCustom = styled.div`
//   padding: 0;
//   margin: 0;
//   margin: 15px;
//   @media (min-width: ${MEDIA_SIZE_FLIP}) {
//     margin: 43px;
//   }
// `;

const MagicNumberSection = styled.section`
  border: 2px solid var(--color-brand-800);
  border-radius: var(--border-radius-md);
  padding: 15px 30px;
  margin: 0 auto;
  margin-bottom: 40px;
  margin-top: 30px;
  @media (min-width: ${MEDIA_SIZE_LG}) {
    padding: 30px 60px;
  }
`;

const StyleduserName = styled.h6`
  color: var(--color-brand-800);
  text-transform: capitalize;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 15px;
  @media (min-width: ${MEDIA_SIZE_LG}) {
    font-size: 36px;
  }
`;

const StyledGreeting = styled.p`
  color: var(--color-text-primary);
  font-size: 18px;
  @media (min-width: ${MEDIA_SIZE_LG}) {
    font-size: 28px;
  }
`;

const ProgressBox = styled.div`
  max-width: 300px;
  padding: 20px;
  border-width: 1px;
  border-style: solid;
  border-radius: var(--border-radius-md);
  border-color: ${(props) =>
    props.variation === "error" ? "var(--color-brand-800)" : "#28A745"};
  background-color: ${(props) =>
    props.variation === "error" ? "#C1393D0D" : "#28A7450D"};
  margin: auto;
`;

const ProgressScore = styled.p`
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 8px;
  color: ${(props) =>
    props.variation === "error" ? "var(--color-brand-800)" : "#28A745"};
`;
const ProgressLabel = styled.p`
  font-weight: 600;
  text-align: center;
  color: var(--color-text-primary);
  margin-bottom: 8px;
`;
const ProgressBar = styled.div`
  max-width: 260px;
  background-color: #ccc;
  height: 15px;
  border-radius: var(--border-radius-md);
`;
const ProgressBarFloat = styled.div`
  width: 10%;
  height: 14px;
  background-color: ${(props) =>
    props.variation === "error" ? "var(--color-brand-800)" : "#28A745"};
  color: transparent;
  padding: 0;
  margin: 0;
  border-radius: var(--border-radius-md);
`;

const StyledChartSection = styled.section`
  padding: 40px 6px 6px 6px;
  position: relative;
  margin: 0 auto;
  width: 80vw;
`;

const StyledDonutchartContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 200px;
  padding: 10px;
  /* @media (min-width: ${MEDIA_SIZE_LG}) {
    padding: 3px;
  } */
`;
// squad styles
const SquadContainer = styled.div`
  padding: 10px;
`;
const SquadContentBox = styled.div`
  border: 1px solid var(--color-text-primary);
  border-radius: var(--border-radius-sm);
`;
const SquadRank = styled.p`
  font-size: 32px;
  color: var(--color-brand-800);
  font-style: italic;
  margin: 0;
  @media (min-width: ${MEDIA_SIZE_LG}) {
    font-size: 64px;
  }
`;
const SquadImg = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  /* box-shadow: var(--shadow-lg); */
`;

const SquadName = styled.p`
  font-size: 18px;
  font-weight: var(--font-weight-medium);
  color: var(--color-brand-800);
  text-transform: capitalize;
  margin: 8px 0;
`;
const SquadHeader = styled.p`
  font-size: 14px;
  color: var(--color-text-secondary);
  text-transform: capitalize;
  margin: 0;
  margin-bottom: 8px;
`;
const SquadText = styled.p`
  font-size: 16px;
  color: var(--color-text-primary);
  font-weight: var(--font-weight-bold);
  margin: 0;
  margin-bottom: 8px;
`;
//title

const StyledSelectContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-right: 20px;
  margin-top: 35px;
  @media (min-width: ${MEDIA_SIZE_MD}) {
    margin-top: 20px;
  }
`;
const StyledSelect = styled.select`
  && {
    border: 1px solid var(--color-secondary-border);
    color: var(--color-text-primary);
    padding: 5px 10px 5px 5px;
    font-size: 14px;
    text-transform: capitalize;
    background: none !important;
    appearance: auto;
    border-radius: 6px;
    &:focus,
    :focus-visible {
      outline: none;
      border-color: var(--color-secondary-border);
    }
    @media (min-width: ${MEDIA_SIZE_MD}) {
      padding-right: 300px;
    }
  }
`;
const StyledOption = styled.option`
  /* cursor: pointer;
  line-height: 30px;
  padding: 10px; */
`;

// default props
ProgressBox.defaultProps = {
  variation: "error",
};
ProgressScore.defaultProps = {
  variation: "error",
};
ProgressBarFloat.defaultProps = {
  variation: "error",
};

const testDetailsColors = [
  "linear-gradient(180deg, #FF6384 0%, #803242 100%)", //1
  "linear-gradient(180deg, #FFCD56 0%, #80672B 100%)", //2
  "linear-gradient(180deg, #4BC0C0 0%, #266060 100%)", //3
  "linear-gradient(180deg, #FF9F40 0%, #805020 100%)", //4
  "linear-gradient(180deg, #36A2EB 0%, #1B5176 100%)", //5
  "linear-gradient(180deg, #D9D9D9 0%, #7F665B 100%)", //6
  "linear-gradient(180deg, #F274BC 0%, #913169 100%)", //7
  "linear-gradient(180deg, #9966FF 0%, #4D3380 100%)", //8
  // "linear-gradient(180deg, #9966FF 0%, #4D3380 100%)", //8
  "linear-gradient(180deg, #96C0AF 0%, #42725F 100%)", //9
];

const TIME_ALLOCATION_LABELS = [
  "Optimum Time",
  "Time Taken by You",
  "Time Taken by Topper",
];
const TIME_FIXING_BY_MINUTE = 1; //0.0166
const ADDED_VALUE = 1; //1
const PAGE_TEST_PERFOMANCE_LIST = "TestPerformanceListView";

export default function ViewInterviewPerfomance() {
  const numberOfStudents_class = 150;
  const numberOfStudents_batch = 754;
  const perfomancelabels = Array.from(
    { length: 11 },
    (_, i) => `Weekly Test ${String(i + 1).padStart(2, 0)}`
  );
  const userJSON = sessionStorage.getItem("userDetails");
  const user = userJSON ? JSON.parse(userJSON) : null;
  const user_id = user?.user_id;
  const user_type = user?.user_type;
  // const full_name = user?.full_name;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { Type, id } = useParams();

  const {
    batchID = 0,
    eventID = 0,
    userID = 0,
    type_batch = 1,
    METHODODTEST = 0,
    ANSWESHEET,
    ANSWERKEY,
    QUESTIONPAPER,
    ATTENDSTATUS,
    panelID = 0,
    SEARCHTERM,
    DATE,
    DATEON,
    INTERVIEWMODE,
    CATEGORY,
    INTERVIEWID,
    PANELID,
    STATUS,
    ACTIVETAB,
    BATCHID,
    STUDENTID,
  } = location.state || {};
  const [resultPublished, setResultPublished] = useState(false);
  const [perfomanceData, setPerfomanceData] = useState({
    isLoading: true,
    methodOfTest: METHODODTEST ? METHODODTEST : 0,
    batchID: batchID,
    eventID: eventID,
    title: "",
    date: new Date(),
    firstName: "",
    lastName: "",
    ans_sheet_download_req: "",
    studentScore: null,
    cutOffScore: 0,
    studentCorePercentage: 0,
    cutoffPercentage: 0,
    totalQuestions: 0,
    totalMarks: 100, // Fixed for interview
    answeredQuestion: 0,
    unAnsweredQuestions: 0,
    correctQuestion: 0,
    inCorrectQuestions: 0,
    marksObtained: 0,
    classRank: 0,
    overallRank: 0,
    classStudents: 0,
    overallStudents: 0,

    squadDetails: [],
    testTypes: [],
    subjectsList: [],
    timeTakenSubjectList: [],
    // CHART
    perfomanceSelectType: -1,
    subjectWiseSelectType: -1,
    timeTakenSelectType: -1,
    selectLoading: false,

    // New interview specific data
    maximumMarks: 100,
    panelMark: 0,
    slabMark: 0,
    rank: 0,
    averageMarks: {
      personality: 0,
      general_knowledge: 0,
      departmental_knowledge: 0,
      core_subject: 0,
      habit: 0,
      leadership: 0,
      communication: 0,
      problem_solving: 0,
      computer_proficiency: 0,
      logical_skill: 0,
    },
    staffMarks: [],
    interviewPerformance: {},
  });

  const [scoreImage, setScoreImage] = useState({
    OutStandingScore: 100,
    ExcellentStartScore: 90,
    ExcellentEndScore: 99,
    VeryGoodStartScore: 80,
    VeryGoodEndScore: 89,
    GoodStartScore: 70,
    GoodEndScore: 79,
    AAverageStartScore: 60,
    AAverageEndScore: 69,
    AverageStartScore: 50,
    AverageEndScore: 59,
    BAverageScore: 50,
  });

  const [isOverallForOvarallAnalysis, setIsOverallForOvarallAnalysis] =
    useState(true);
  const [overallAnalysisLabel, setOverallAnalysisLabel] = useState("Test Type");
  // chart data
  const perfomanceChartData = useSelector(
    (state) => state.chart.perfomanceAnalysis
  );
  const overallChartData = useSelector((state) => state.chart.overallAnalysis);
  const proficiencySubjectsChartData = useSelector(
    (state) => state.chart.proficiencySubjectAnalysis
  );
  const difficultyTypeChart = useSelector(
    (state) => state.chart.queDifficultyAnalysis
  );
  const timeTakenChart = useSelector((state) => state.chart.timeTakenAnalysis);
  const slabConfig = {
    Outstanding: {
      image: IMAGE_outstanding,
      message: (
        <>
          You are an Outstanding Student!
          <br />
          AIASA is very proud of you!
        </>
      ),
    },
    Excellent: {
      image: IMAGE_Excellent,
      message: "Excellent! You have such a great future ahead of you!",
    },
    "Very Good": {
      image: IMAGE_VGood,
      message: (
        <>
          You are on the right path!
          <br />
          Keep up the good work!
        </>
      ),
    },
    Good: {
      image: IMAGE_Good,
      message: (
        <>
          You have the potential to achieve!
          <br />
          Needs slight improvement!
        </>
      ),
    },
    Average: {
      image: IMAGE_Average,
      message: (
        <>
          Your future depends on what you do today!
          <br />
          Focus more on your studies!
        </>
      ),
    },
    "Above Average": {
      image: IMAGE_AAverage, // You're already importing this
      message: (
        <>
          You're doing well!
          <br />
          Keep striving for excellence!
        </>
      ),
    },
    Average: {
      image: IMAGE_Average,
      message: (
        <>
          Your future depends on what you do today!
          <br />
          Focus more on your studies!
        </>
      ),
    },
    Satisfactory: {
      image: IMAGE_Average, // You can reuse an existing image or add a new one
      message: (
        <>
          Your performance is satisfactory!
          <br />
          There's room for improvement!
        </>
      ),
    },
    "Needs Improvement": {
      image: IMAGE_BAverage, // You're already importing this as BelowAverage
      message: (
        <>
          Identify areas for improvement!
          <br />
          Consistent effort will yield results!
        </>
      ),
    },
    "Below Expectations": {
      image: IMAGE_BAverage, // You can reuse or add a new image
      message: (
        <>
          Your performance needs attention!
          <br />
          Seek guidance and work harder!
        </>
      ),
    },
    Unsatisfactory: {
      image: IMAGE_BAverage, // You can reuse or add a new image
      message: (
        <>
          Immediate improvement required!
          <br />
          Contact your mentor for guidance!
        </>
      ),
    },
    "Below Average": {
      image: IMAGE_BAverage,
      message: (
        <>
          Believe in your ability to succeed.
          <br />
          Work hard to improve!
        </>
      ),
    },
  };

  // ###DERIVED STATE
  const testDetails = [
    { label: "Total No. of Questions", value: perfomanceData.totalQuestions },
    { label: "Total Marks", value: perfomanceData.totalMarks },
    {
      label: "No. of Questions Answered",
      value: perfomanceData.answeredQuestion,
    },
    {
      label: "No. of Questions Unanswered",
      value: perfomanceData.unAnsweredQuestions,
    },
    {
      label: "No. of Questions Correct",
      value: perfomanceData.correctQuestion,
    },
    {
      label: "No. of Questions Incorrect",
      value: perfomanceData.inCorrectQuestions,
    },
    { label: "Obtained Marks", value: perfomanceData.marksObtained },
    {
      label: "Class Rank",
      value: `${perfomanceData.classRank} / ${perfomanceData.classStudents}`,
    },
    {
      label: "Overall Rank",
      value: `${perfomanceData.overallRank} / ${perfomanceData.overallStudents}`,
    },
  ];

  const testDetails_Descriptive = [
    { label: "Total No. of Questions", value: perfomanceData.totalQuestions },
    { label: "Total Marks", value: perfomanceData.totalMarks },
    {
      label: "No. of Questions Answered",
      value: perfomanceData.answeredQuestion,
    },
    { label: "Obtained Marks", value: perfomanceData.marksObtained },
    {
      label: "Class Rank",
      value: `${perfomanceData.classRank} / ${perfomanceData.classStudents}`,
    },
    {
      label: "Overall Rank",
      value: `${perfomanceData.overallRank} / ${perfomanceData.overallStudents}`,
    },
  ];

  //for Model exam
  const testDetails_modelexam = [
    { label: "Total Marks", value: perfomanceData.totalMarks },
    { label: "Obtained Marks", value: perfomanceData.marksObtained },
    {
      label: "Class Rank",
      value: `${perfomanceData.classRank} / ${perfomanceData.classStudents}`,
    },
  ];
  const PERFOMANCE_CHART_TITLE = perfomanceData.testTypes.some((test) => {
    return test.id === perfomanceData.perfomanceSelectType;
  })
    ? perfomanceData.testTypes.find((test) => {
        return test.id === perfomanceData.perfomanceSelectType;
      }).name
    : "Overall"; //New Changes

  // ###FUNCTIONS
  const getPerfomanceChartTitle = (value) => {
    const title = perfomanceData.testTypes.some((test) => {
      return test.id === value;
    })
      ? perfomanceData.testTypes.find((test) => {
          return test.id === value;
        }).name
      : "Overall"; //New Changes

    return title;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "perfomanceSelect") {
      setPerfomanceData((prevData) => ({ ...prevData, selectLoading: true }));
      const formdata = {
        batch_id: perfomanceData.batchID,
        event_id: perfomanceData.eventID,
        user_id: userID,
        type: CHART_PERFOMANCE,
        overall: +value === -1 ? 1 : 0,
      };
      if (+value !== -1) formdata.test_type_pk = +value;
      // return alert('lakshmaan')
      studentPerfomanceChart(formdata)
        .then((res) => {
          if (res.status) {
            let topperScore = [];
            let labels = [];
            const { score_with_top: scores } = res.data;
            if (!scores?.curr_user) {
              // send empty array if data is empty
              toast.error(`${getPerfomanceChartTitle(+value)} Not Yet Taken`);
              return null;
            }
            const topperScores = scores.topper;
            const sortedUserScores = scores.curr_user.sort(
              (a, b) => parseFloat(a.event_pk) - parseFloat(b.event_pk)
            );
            const studentScore = sortedUserScores.map((score) => {
              const eventValue = topperScores.some(
                (topScore) => topScore.event_pk === score.event_pk
              )
                ? topperScores.find(
                    (topscore) => topscore.event_pk === score.event_pk
                  ).marks_in_perc
                : 0;
              topperScore.push(eventValue);
              labels.push(score.event_type_title);
              return score.marks_in_perc;
            });
            dispatch(createPerfomanceLabels(labels));
            dispatch(createPerfomanceTopperScore(topperScore));
            dispatch(createPerfomanceStudentScore(studentScore));

            setPerfomanceData((prevData) => ({
              ...prevData,
              perfomanceSelectType: +value,
            }));
          } else {
            console.error("studentPerfomanceChart api error");
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() =>
          setPerfomanceData((prevData) => ({
            ...prevData,
            selectLoading: false,
          }))
        );
    } else if (name === "subjectWiseSelect") {
      setPerfomanceData((prevData) => ({ ...prevData, selectLoading: true }));
      const formData = {
        batch_id: perfomanceData.batchID,
        event_id: perfomanceData.eventID,
        user_id: userID,
        type: CHART_PROFICIENCY_SUBJECTS,
        overall: +value === -1 ? 1 : 0,
      };
      studentPerfomanceChart(formData)
        .then((res) => {
          if (res.status) {
            const { sub_cnt } = res.data;

            // new
            const arrayOfOverallAndSubjects = sub_cnt.flatMap((ele) => {
              if (ele.single) {
                //--> if subject contains each subjects it will return overall+subjects
                // overwrite subject_name for overall
                ele.subject_name = `${ele.subject_overall}-overall`;
                // if (ele.single.length > 1) {
                // }
                const singleArray = ele.single.map((eleS, indexS, arrS) => {
                  // overwrite subject_name with overallSubjectName+subjectName
                  eleS.subject_name = `${ele.subject_overall}-${eleS.subject_name}`;
                  // if (arrS.length > 1) {
                  // }
                  return eleS;
                });
                // removing single key from object for perfomance
                delete ele.single;
                return [ele, ...singleArray];
              }
              // else return overall only
              return ele;
            });
            // new
            dispatch(
              createProficiencySubjectAnalysisScore(arrayOfOverallAndSubjects)
            );
            setPerfomanceData((prevData) => ({
              ...prevData,
              subjectWiseSelectType: value,
            }));
          } else {
            console.error("studentPerfomanceChart subject0-wise api error");
          }
        })
        .catch((err) => console.error(err))
        .finally(() =>
          setPerfomanceData((prevData) => ({
            ...prevData,
            selectLoading: false,
          }))
        );
    } else if (name === "timeTakenSelect") {
      setPerfomanceData((prevData) => ({ ...prevData, selectLoading: true }));
      const formData = {
        batch_id: perfomanceData.batchID,
        event_id: perfomanceData.eventID,
        user_id: userID,
        type: CHART_SUBJECT_TIME_TAKEN,
        overall: +value === -1 ? 1 : 0,
      };
      if (+value !== -1) {
        formData.subject = value;
      }
      studentPerfomanceChart(formData)
        .then((res) => {
          if (res.status) {
            const { sub_time } = res.data;
            if (!sub_time.time_taken_by_stud) {
              toast.error(`${value} is not available`);
            } else {
              // fixed when showing 30 mins testas 31 mis test
              // const timeTakenData = [
              //   Math.ceil(sub_time.optimum_time * TIME_FIXING_BY_MINUTE),
              //   Math.ceil(sub_time.time_taken_by_stud * TIME_FIXING_BY_MINUTE),
              //   Math.ceil(
              //     sub_time.time_taken_by_topper * TIME_FIXING_BY_MINUTE
              //   ),
              // ];
              const timeTakenData = [
                parseInt(sub_time.optimum_time * TIME_FIXING_BY_MINUTE),
                sub_time.time_taken_by_stud * TIME_FIXING_BY_MINUTE,
                sub_time.time_taken_by_topper * TIME_FIXING_BY_MINUTE,
              ];

              dispatch(createSubjectWiseTimeTaken(timeTakenData));
              setPerfomanceData((prevData) => ({
                ...prevData,
                timeTakenSelectType: value,
              }));
            }
          } else {
            console.error("studentPerfomanceChart timetaken api error");
          }
        })
        .catch((err) => console.error(err))
        .finally(() =>
          setPerfomanceData((prevData) => ({
            ...prevData,
            selectLoading: false,
          }))
        );
    } else {
      console.error(`un handled handlechange type from ${name}`);
    }
  };
  const handleBackToTestType = () => {
    const formData = {
      batch_id: perfomanceData.batchID,
      event_id: perfomanceData.eventID,
      user_id: userID,
      type: CHART_OVERALL,
      overall: 1,
    };
    handleSelectLoading(true);
    studentPerfomanceChart(formData)
      .then((res) => {
        if (res.status) {
          const { scores } = res.data;
          const modifiedTestTypes = perfomanceData.testTypes.map((test) => ({
            name: test.name,
            mark: 0,
            testType: test.id,
          }));
          // 1.add marks based on testypepk
          const wantedScore = modifiedTestTypes.map((modifyTest) => {
            if (
              scores.some((score) => score.test_type_pk === modifyTest.testType)
            ) {
              const changedMark = scores.find(
                (findScore) => findScore.test_type_pk === modifyTest.testType
              )?.marks_in_perc;
              return {
                name: modifyTest.name,
                mark: changedMark,
                testType: modifyTest.testType,
              };
            } else {
              return modifyTest;
            }
          });
          // 2.choose fixedtypes+usertestTypes
          const fixedTestTypes = [
            TESTTYPE_DAILY,
            TESTTYPE_WEEK,
            TESTTYPE_MONTH,
            TESTTYPE_REVISION,
            TESTTYPE_TOPIC_WISE,
            TESTTYPE_UNIT_WISE,
            TESTTYPE_SPOT,
            TESTTYPE_MODEL,
          ];
          const userTestTypes = scores.flatMap((score) => {
            if (!fixedTestTypes.includes(score.test_type_pk)) {
              return score.test_type_pk;
            } else {
              return [];
            }
          });
          const finalisedTestTypes = [...fixedTestTypes, ...userTestTypes];
          // 3.eliminate other testtypes
          const finalisedScore = wantedScore.flatMap((wscore) => {
            const tempTestType = wscore.testType;
            if (finalisedTestTypes.includes(tempTestType)) {
              return wscore;
            } else {
              return [];
            }
          });
          dispatch(createOverallAnalysisScore(finalisedScore));
          setIsOverallForOvarallAnalysis(true);
          setOverallAnalysisLabel("Test Type");
        } else {
          throw new Error(" overall score chart api error");
        }
      })
      .catch((err) => console.error(err))
      .finally(() => handleSelectLoading(false));
  };
  const handleSelectLoading = (flag) => {
    setPerfomanceData((prevData) => ({ ...prevData, selectLoading: flag }));
  };

  const handleRetakeTest = () => {
    let dt = {
      batch_id: parseInt(batchID),
      event_id: parseInt(eventID),
      user_id: userID,
    };

    AxiosInstance.post("api/test/start", dt)
      .then((res) => {
        if (res.data.status === true) {
          let startTime =
            res.data.data[0].start_time != null
              ? res.data.data[0].start_time
              : "";
          let endTime =
            res.data.data[0].end_time != null ? res.data.data[0].end_time : "";
          let batch_id = res.data.data[0].batch_id;
          let event_id = res.data.data[0].event_id;
          let no_ques = res.data.data[0].no_of_questions;
          let tol_mark = res.data.data[0].tot_marks;
          // let attempt_no =  (fdata.obtained_marks !==null && fdata.obtained_marks !=="") ? res.data.data[0].attempt : 2 ;
          let attempt_no = res.data.data[0].attempt;
          let method_of_test = res.data.data[0].method_of_test;
          let event_name = res.data.data[0].event_name;
          let type_type_name = res.data.data[0].name;
          let start_date_test = res.data.data[0].start_date;
          let description = res.data.data[0].description;
          const navState = res.data.data[0];
          navigate(res.data.data[0].teams_url, {
            state: {
              eventName: event_name,
              methodOfTest: method_of_test,
              testType: type_type_name,
              date: start_date_test,
              startTime: startTime,
              endTime: endTime,
              totalNoQues: no_ques,
              totalMark: tol_mark,
              descForStudent: description,
              batchID: batch_id,
              eventID: event_id,
              attempt_no: attempt_no,
            },
          });
          // Remove buttonClickCount from sessionStorage
          sessionStorage.removeItem("buttonClickCount");
          // window.location.reload();
        } else {
          toast.error(
            "You've reached the maximum limit of 2 re-takes, so another attempt isn't possible."
          );
          // navigate("/");
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const navigateToPreviousScreen = () => {
    navigate(`/StudentFeedBackList`, {
      state: {
        filSearch: SEARCHTERM,
        filInterviewMode: INTERVIEWMODE,
        filCategory: CATEGORY,
        filDate: DATE,
        filDateOn: DATEON,
        filStatus: STATUS,
        FILActiveTab: ACTIVETAB,
        filBatchId: BATCHID,
      },
    });
  };
  const handleDownloadAnswerSheet = () => {
    const formData = {
      user_id: userID,

      batch_id: perfomanceData.batchID,

      event_id: perfomanceData.eventID,
    };
    AxiosInstance.post("api/test/answer/download", formData)
      .then((res) => {
        handleSelectLoading(true);
        if (res.data.status) {
          const { path } = res.data.data;
          if (path) window.open(`${ImageUrlPrefix}/${path}`);
        } else {
          throw new Error("download answer sheet pdf error");
        }
      })
      .catch((err) => console.error(err))
      .finally(() => handleSelectLoading(false));
  };
  const handleReviewSubmission = () => {
    navigate(
      `/ReviewSubmission/${perfomanceData.batchID}/${perfomanceData.eventID}`
    );
  };

  // Fetch interview performance data
  const fetchInterviewPerformance = () => {
    setPerfomanceData((prevData) => ({ ...prevData, isLoading: true }));

    const formData = {
      user_id: STUDENTID,
      interview_id: INTERVIEWID,
      panel_id: PANELID,
      staff_id: "",
    };

    AxiosInstance.post("api/mockinterview/interview/view_marks", formData)
      .then((res) => {
        if (res.data.status) {
          const data = res.data;

          // Calculate total panel mark from staff marks
          let totalPanelMark = 0;
          let panelMarkCount = 0;

          if (data.staffMarks && data.staffMarks.length > 0) {
            data.staffMarks.forEach((staff) => {
              const staffTotal =
                (staff.personality || 0) +
                (staff.general_knowledge || 0) +
                (staff.departmental_knowledge || 0) +
                (staff.core_subject || 0) +
                (staff.habit || 0) +
                (staff.leadership || 0) +
                (staff.communication || 0) +
                (staff.problem_solving || 0) +
                (staff.computer_proficiency || 0) +
                (staff.logical_skill || 0);

              totalPanelMark += staffTotal;
              panelMarkCount++;
            });
          }

          const averagePanelMark =
            panelMarkCount > 0
              ? Math.round(totalPanelMark / panelMarkCount)
              : 0;
          const interviewPerf = data.interview_performance?.[0] || {};
          setResultPublished(
            Array.isArray(data.interview_performance) &&
              data.interview_performance.length > 0 &&
              data.interview_performance[0].result_status === 1
          );
          // Update performance data with API response
          setPerfomanceData((prev) => ({
            ...prev,
            isLoading: false,
            studentName: data.student_name || "", // ✅ ADD THIS
            slabName: interviewPerf.slab_name || "", // ✅ ADD THIS
            // ✅ USE API VALUES
            stpanelMark: interviewPerf.panel_mark || 0,
            stslabMark: interviewPerf.slab_mark || 0,
            strank: interviewPerf.event_rank || 0,
            panelMark: averagePanelMark,
            slabMark: data.interview_performance?.[0]?.slab_mark || 0,
            rank: data.interview_performance?.[0]?.event_rank || 0,
            averageMarks: data.total_avg || {
              personality: 0,
              general_knowledge: 0,
              departmental_knowledge: 0,
              core_subject: 0,
              habit: 0,
              leadership: 0,
              communication: 0,
              problem_solving: 0,
              computer_proficiency: 0,
              logical_skill: 0,
            },
            staffMarks: data.staffMarks || [],
            interviewPerformance: data.interview_performance?.[0] || {},
            squadDetails: data.FetchTopStud || [],
            marksObtained: averagePanelMark,
            studentScore: averagePanelMark,
            studentCorePercentage: averagePanelMark, // Since total marks is 100
            classRank: data.interview_performance?.[0]?.event_rank || 0,
            classStudents: data.FetchTopStud?.length || 0,
            overallRank: data.interview_performance?.[0]?.event_rank || 0,
            overallStudents: data.FetchTopStud?.length || 0,
          }));
        } else {
          console.error("Interview performance API error");
          toast.error("Failed to load interview performance data");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error loading interview performance data");
      })
      .finally(() => {
        setPerfomanceData((prevData) => ({ ...prevData, isLoading: false }));
      });
  };

  useEffect(() => {
    // For interview performance, use the new API
    fetchInterviewPerformance();
  }, []);

  return (
    <CustomContainer>
      <section
        id="title"
        className="row justify-content-center align-items-center p-0 "
        style={{ margin: "10px 0" }}
      >
        <div className="col-12 col-lg-4">
          <StyledTitle>View Interview Performance</StyledTitle>
        </div>
        <div className="col-12 col-lg-8">
          <ButtonContainer>
            <SecondaryButton
              onClick={() => {
                user_type !== 2 ? navigate(-1) : navigateToPreviousScreen();
              }}
            >
              {user_type !== 2
                ? "Back to View Student"
                : "Back to Interview Performance"}
            </SecondaryButton>
          </ButtonContainer>
        </div>
      </section>

      {perfomanceData.isLoading ? (
        <SkeletonLoaderPage />
      ) : (
        <>
          {![3, 4, 5].includes(user_type) &&
            perfomanceData.squadDetails?.length > 0 && (
              <MagicNumberSection>
                <div className="row">
                  <div className="col-12 col-md-4 m-0 p-0 mb-4 mb-md-0">
                    <div className="d-flex justify-content-center">
                      {slabConfig[perfomanceData.slabName] && (
                        <img
                          src={slabConfig[perfomanceData.slabName].image}
                          alt="result"
                          className="img-fluid"
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className="col-12 col-md-5
           m-0 p-0 mb-3 mx-md-0 my-md-auto"
                  >
                    <StyleduserName className="text-center text-md-start">
                      {`Hi ${perfomanceData.studentName}`}
                    </StyleduserName>

                    {(() => {
                      const score = perfomanceData.studentCorePercentage;

                      if (score === scoreImage.OutStandingScore) {
                        return (
                          <StyledGreeting className="text-center text-md-start">
                            You are an Outstanding Student!
                            <br />
                            AIASA is very proud of you!
                          </StyledGreeting>
                        );
                      } else if (
                        score >= scoreImage.ExcellentStartScore &&
                        score <= scoreImage.ExcellentEndScore
                      ) {
                        return (
                          <StyledGreeting className="text-center text-md-start">
                            Excellent! You have such a great future ahead of
                            you!
                          </StyledGreeting>
                        );
                      } else if (
                        score >= scoreImage.VeryGoodStartScore &&
                        score <= scoreImage.VeryGoodEndScore
                      ) {
                        return (
                          <StyledGreeting className="text-center text-md-start">
                            You are on the right path!
                            <br />
                            Keep up the good work !
                          </StyledGreeting>
                        );
                      } else if (
                        score >= scoreImage.GoodStartScore &&
                        score <= scoreImage.GoodEndScore
                      ) {
                        return (
                          <StyledGreeting className="text-center text-md-start">
                            You have the potential to achieve!
                            <br />
                            Needs slight improvement!
                          </StyledGreeting>
                        );
                      } else if (
                        score >= scoreImage.AAverageStartScore &&
                        score <= scoreImage.AAverageEndScore
                      ) {
                        return (
                          <StyledGreeting className="text-center text-md-start">
                            Believe in your ability to succeed.
                            <br />
                            Work hard to make your dreams a reality.
                          </StyledGreeting>
                        );
                      } else if (
                        score >= scoreImage.AverageStartScore &&
                        score <= scoreImage.AverageEndScore
                      ) {
                        return (
                          <StyledGreeting className="text-center text-md-start">
                            Your future depends on what you do today!
                            <br />
                            Focus more on your studies! With continuous efforts
                            you can achieve !
                          </StyledGreeting>
                        );
                      } else if (score < scoreImage.BAverageScore) {
                        return (
                          <StyledGreeting className="text-center text-md-start">
                            Below Average - Time to improve!
                            <br />
                            Focus on fundamentals and practice regularly!
                          </StyledGreeting>
                        );
                      } else {
                        // Default or fallback message
                        return (
                          <StyledGreeting className="text-center text-md-start">
                            Keep working hard!
                            <br />
                            Your efforts will pay off!
                          </StyledGreeting>
                        );
                      }
                    })()}
                  </div>
                  <div className="col-12 col-md-3 m-0 p-0 mb-3 mx-md-0 my-md-auto">
                    <div>
                      <ProgressBox
                        variation="success"
                        style={{
                          marginBottom: "20px",
                        }}
                      >
                        <ProgressScore variation="success">
                          {perfomanceData.stpanelMark || 0}
                        </ProgressScore>
                        <ProgressLabel>Panel Mark</ProgressLabel>
                        <ProgressBar>
                          <ProgressBarFloat
                            variation="success"
                            style={{
                              width: `${perfomanceData.stpanelMark || 0}%`,
                              minWidth: "1%",
                              maxWidth: "100%",
                              // maxWidth: "100%",
                            }}
                          ></ProgressBarFloat>
                        </ProgressBar>
                      </ProgressBox>
                      {type_batch !== "4" && (
                        <ProgressBox>
                          <ProgressScore>
                            {perfomanceData.stslabMark || 0}
                          </ProgressScore>
                          <ProgressLabel>Slab Mark</ProgressLabel>
                          <ProgressBar>
                            <ProgressBarFloat
                              style={{
                                width: `${perfomanceData.stslabMark || 0}%`,
                                minWidth: "1%",
                                maxWidth: "100%",
                              }}
                            ></ProgressBarFloat>
                          </ProgressBar>{" "}
                        </ProgressBox>
                      )}
                    </div>
                  </div>
                </div>
              </MagicNumberSection>
            )}
          {/* Mark Details */}
          <div className="container-fluid  p-0  global_container mb-4">
            <div className="purchase">
              <fieldset className="mt-3">
                <legend className="w-auto">Mark Details</legend>

                <div className="row">
                  <div className="col-md-3">
                    <p className="confirm_label">Maximum Marks</p>
                    <p className="confirm_value">
                      {perfomanceData.maximumMarks}
                    </p>
                  </div>

                  <div className="col-md-3">
                    <p className="confirm_label">Panel Mark</p>
                    <p className="confirm_value">{perfomanceData.panelMark}</p>
                  </div>

                  <div className="col-md-3">
                    <p className="confirm_label">Slab Mark</p>
                    <p className="confirm_value">{perfomanceData.slabMark}</p>
                  </div>

                  <div className="col-md-3">
                    <p className="confirm_label">Rank</p>
                    <p className="confirm_value">{perfomanceData.rank}</p>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          {/* top 10 squad */}
          {![3, 4, 5].includes(user_type) &&
            perfomanceData.squadDetails?.length > 0 && (
              <FloatedTitleContainer title="Top 10 Squad">
                <div
                  className="row align-items-center mt-3 p-0"
                  style={{ margin: "20px 10px" }}
                >
                  {perfomanceData.squadDetails &&
                  perfomanceData.squadDetails.length > 0 ? (
                    perfomanceData.squadDetails.map((squad, index) => {
                      const splittedTime =
                        squad.duration_completed !== null &&
                        squad.duration_completed !== undefined
                          ? squad.duration_completed.split(":")
                          : [];
                      return (
                        <SquadContainer
                          className="col-12 col-md-6 m-0 "
                          key={index}
                        >
                          <SquadContentBox>
                            <div className="row p-1 m-0 justify-content-center align-items-center">
                              <div className="col-6 col-lg-2 m-0 p-0">
                                <div className="d-flex justify-content-center align-items-center">
                                  <SquadRank>{squad.event_rank}</SquadRank>
                                </div>
                              </div>
                              <div className="col-6 col-lg-3">
                                <SquadImg
                                  src={`${ImageUrlPrefix}/${
                                    squad.profile_path || ""
                                  }`}
                                  className="img-fluid"
                                  alt="student profile"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = `${ImageUrlPrefix}/uploads/profiles/default-profile.png`;
                                  }}
                                />
                              </div>
                              <div className="col-12 col-lg-7">
                                <SquadName>{`${squad.first_name || ""} ${
                                  squad.last_name || ""
                                }`}</SquadName>

                                <div className="row p-0 m-0">
                                  <div className="col-6 p-0 m-0">
                                    <SquadHeader>Obtained Marks</SquadHeader>
                                    <SquadText>{`${squad.panel_mark || 0} / ${
                                      squad.Total_mark || 100
                                    }`}</SquadText>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </SquadContentBox>
                        </SquadContainer>
                      );
                    })
                  ) : (
                    <div className="col-12 text-center">
                      <p>No squad data available</p>
                    </div>
                  )}
                </div>
              </FloatedTitleContainer>
            )}
          {/* Mark Details */}
          <div className="container-fluid  p-0  global_container">
            <div className="purchase">
              <fieldset className="mt-3">
                <legend className="w-auto">Average Panel Mark</legend>

                <div className="row">
                  <div className="col-md-3">
                    <p className="confirm_label">Personality</p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.personality || 0}
                    </p>
                  </div>

                  <div className="col-md-3">
                    <p className="confirm_label">General Knowledge</p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.general_knowledge || 0}
                    </p>
                  </div>

                  <div className="col-md-3">
                    <p className="confirm_label">Departmental Knowledge</p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.departmental_knowledge || 0}
                    </p>
                  </div>

                  <div className="col-md-3">
                    <p className="confirm_label">Core Subject Knowledge</p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.core_subject || 0}
                    </p>
                  </div>

                  <div className="col-md-3 mt-2">
                    <p className="confirm_label">Habit of Reading</p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.habit || 0}
                    </p>
                  </div>

                  <div className="col-md-3 mt-2">
                    <p className="confirm_label">Leadership Quality</p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.leadership || 0}
                    </p>
                  </div>

                  <div className="col-md-3 mt-2">
                    <p className="confirm_label">Communication Skills</p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.communication || 0}
                    </p>
                  </div>

                  <div className="col-md-3 mt-2">
                    <p className="confirm_label">
                      Problem Solving and Decision Making
                    </p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.problem_solving || 0}
                    </p>
                  </div>

                  <div className="col-md-3 mt-2">
                    <p className="confirm_label">
                      Logical and Analytical Skill
                    </p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.logical_skill || 0}
                    </p>
                  </div>

                  <div className="col-md-3 mt-2">
                    <p className="confirm_label">Computer Proficiency</p>
                    <p className="confirm_value">
                      {perfomanceData.averageMarks.computer_proficiency || 0}
                    </p>
                  </div>
                </div>
              </fieldset>

              {/* Render each staff member's marks */}
              {perfomanceData.staffMarks &&
              perfomanceData.staffMarks.length > 0 ? (
                perfomanceData.staffMarks.map((staff, staffIndex) => (
                  <fieldset
                    key={staffIndex}
                    className={`mt-3 ${styles.legendRow}`}
                  >
                    {!resultPublished &&
                      (user_type === 1 ||
                        ([3, 4, 5].includes(user_type) &&
                          user_id === staff.user_id)) && (
                        <span
                          className={styles.legendRight}
                          onClick={() =>
                            navigate("/MockInterviewMarksUpdate", {
                              state: {
                                studentId: STUDENTID,
                                interview_id: INTERVIEWID,
                                panel_id: PANELID,
                                STAFFID: staff.staff_id,
                              },
                            })
                          }
                        >
                          <i className="fa fa-edit"></i> Edit Marks
                        </span>
                      )}
                    <legend className={`w-auto ${styles.legendTitle}`}>
                      Panel Mark by{" "}
                      {staff.staff_name || `Panel Member ${staffIndex + 1}`}
                    </legend>

                    <div className="row">
                      <div className="col-md-3">
                        <p className="confirm_label">Personality</p>
                        <p className="confirm_value">
                          {staff.personality || 0}
                        </p>
                      </div>

                      <div className="col-md-3">
                        <p className="confirm_label">General Knowledge</p>
                        <p className="confirm_value">
                          {staff.general_knowledge || 0}
                        </p>
                      </div>

                      <div className="col-md-3">
                        <p className="confirm_label">Departmental Knowledge</p>
                        <p className="confirm_value">
                          {staff.departmental_knowledge || 0}
                        </p>
                      </div>

                      <div className="col-md-3">
                        <p className="confirm_label">Core Subject Knowledge</p>
                        <p className="confirm_value">
                          {staff.core_subject || 0}
                        </p>
                      </div>

                      <div className="col-md-3 mt-2">
                        <p className="confirm_label">Habit of Reading</p>
                        <p className="confirm_value">{staff.habit || 0}</p>
                      </div>

                      <div className="col-md-3 mt-2">
                        <p className="confirm_label">Leadership Quality</p>
                        <p className="confirm_value">{staff.leadership || 0}</p>
                      </div>

                      <div className="col-md-3 mt-2">
                        <p className="confirm_label">Communication Skills</p>
                        <p className="confirm_value">
                          {staff.communication || 0}
                        </p>
                      </div>

                      <div className="col-md-3 mt-2">
                        <p className="confirm_label">
                          Problem Solving and Decision Making
                        </p>
                        <p className="confirm_value">
                          {staff.problem_solving || 0}
                        </p>
                      </div>

                      <div className="col-md-3 mt-2">
                        <p className="confirm_label">
                          Logical and Analytical Skill
                        </p>
                        <p className="confirm_value">
                          {staff.logical_skill || 0}
                        </p>
                      </div>

                      <div className="col-md-3 mt-2">
                        <p className="confirm_label">Computer Proficiency</p>
                        <p className="confirm_value">
                          {staff.computer_proficiency || 0}
                        </p>
                      </div>

                      {/* Comments */}
                      <div className="col-12 mt-3">
                        <p className="confirm_label">Comments</p>
                        <p className="confirm_value">
                          {staff.comments || "No comments provided"}
                        </p>
                      </div>

                      {/* Total Marks for this staff */}
                      {/* <div className="col-12 mt-3">
                        <p className="confirm_label">
                          Total Marks by{" "}
                          {staff.staff_name || `Panel Member ${staffIndex + 1}`}
                        </p>
                        <p
                          className="confirm_value"
                          style={{
                            fontWeight: "bold",
                            color: "var(--color-brand-800)",
                          }}
                        >
                          {calculateStaffTotal(staff)} / 100
                        </p>
                      </div> */}
                    </div>
                  </fieldset>
                ))
              ) : (
                <div className="col-12 text-center mt-3">
                  <p>No staff marks available</p>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </CustomContainer>
  );
}
